/**
 *  Arquivo que contém as constantes com os nomes padrões
 *      para store de convalidações
 */
export const SET_SUBJECTS_VALIDATIONS = 'SUBJECT_VALIDATIONS/SET_SUBJECTS_VALIDATIONS'
